<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-10">
      <v-icon x-large class="v-icon-delete">
        mdi-delete-alert-outline
      </v-icon>

      <div v-if="currentCourseItem">
        <v-card-title class="text-h6 pp-center">
          Are you sure you want to delete course "{{ currentCourseItem.name }}"?
        </v-card-title>

        <p class="pp-center pb-5">
          This course will be deleted immediately. You can't undo this action.
        </p>
      </div>

      <div v-else>
        <UnavailableContent />
      </div>

      <Loading v-if="courseItemLoading"/>

      <ConfirmCancelButtons
          :item="currentCourseItem"
          :confirm-disabled="courseItemLoading"
          confirm-text="Delete Course"
          :confirm-action="deleteItemConfirm"
          cancel-class="mr-5"
          :cancel-action="closeDialog"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import UnavailableContent from "@/components/common/UnavailableContent";

export default {
  name: "CourseDelete",
  components: {UnavailableContent, Loading, ConfirmCancelButtons},
  computed: {
    ...mapState(['currentCourseItem']),
    ...mapGetters(['courseApiError', 'openDialog', 'currentCourseItem', 'courseItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'courseDelete';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['deleteCourse', 'clearCourseItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.reset();
    },
    async deleteItemConfirm() {
      const deleted = await this.deleteCourse(this.currentCourseItem);
      if (deleted) {
        this.reset();
      }
    },
    reset() {
      this.closeOpenDialog();
      this.clearCourseItems();
    },
  },
};
</script>
